
document.addEventListener("DOMContentLoaded", function () {
	const backToTop = document.getElementById("back-to-top");
	let lastKnownScrollPosition = 0;

	window.addEventListener("scroll", function () {
		lastKnownScrollPosition = window.scrollY;

		if (lastKnownScrollPosition >= 500) {
			backToTop.classList.add("visible");
		} else {
			backToTop.classList.remove("visible");
		}
	});

	backToTop.addEventListener("click", function (event) {
			event.preventDefault();
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
	});
});
